<template>
  <v-card class="ma-3">
    <base-loading v-if="loading" />
    <div v-else class="content">
      <template>
        <v-card
          :class="{ 'card-success': cadastro, 'card-warn': !cadastro }"
          style="min-height: 60vh"
        >
          <h4 v-if="!cadastro" slot="header" class="card-title text-center">
            Edição de supervisor
          </h4>
          <h4 v-else slot="header" class="card-title text-center">
            Cadastro de supervisor
          </h4>
          <div class="clearfix" />
          <div>
            <v-form
              id="form"
              ref="form"
              v-model="valid"
              enctype="multipart/form-data"
              class="pa-3"
              lazy-validation
              @submit.prevent="updateCentral"
            >
              <v-card>
                <v-list-item-content>
                  <v-card-title class="headline mx-auto">
                    Dados Pessoais
                  </v-card-title>
                  <v-row v-if="!loading" class="pa-3">
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.nome"
                        label="Nome *"
                        name="nome"
                        :rules="requiredRules"
                        required
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.email"
                        name="email"
                        label="Email *"
                        :rules="emailRules"
                        required
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.cpf"
                        v-mask="maskCpf"
                        name="cpf"
                        label="CPF *"
                        :rules="cpfRules"
                        required
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="form.sexo"
                        :items="sexos"
                        :rules="requiredRules"
                        item-text="text"
                        name="sexo"
                        item-value="text"
                        label="Sexo *"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.telCel"
                        v-mask="maskTelCel"
                        :rules="telRules"
                        label="Telefone Celular *"
                        name="telefone"
                        type="tel"
                        required
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="form.telRes"
                        v-mask="maskTelCel"
                        label="Telefone Comercial"
                        type="tel"
                      />
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-card>
              <v-card>
                <v-list-item-content>
                  <v-card-title class="headline mx-auto">
                    Endereço
                  </v-card-title>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="form.estado"
                      autocomplete="autocomplete_off_hack_xfr4!k"
                      label="Estado *"
                      name="estado"
                      :items="estado"
                      :rules="requiredRules"
                      :loading="loadingEstados"
                      :disabled="loadingEstados"
                      item-text="Nome"
                      item-value="CodEstado"
                      required
                      @change="changeCidade"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="form.CodCidade"
                      name="cidade"
                      autocomplete="autocomplete_off_hack_xfr4!k"
                      label="Cidade *"
                      :loading="loadingCidades"
                      :items="cidade"
                      :rules="requiredRules"
                      item-text="Nome"
                      item-value="CodCidade"
                      required
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.logradouro"
                      label="Logradouro"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="form.numero" label="Numero" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="form.bairro" label="Bairro" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="form.complemento"
                      label="Complemento"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="form.cep"
                      v-mask="maskCep"
                      type="text"
                      label="CEP"
                      name="cep"
                      required
                    />
                  </v-col>
                </v-list-item-content>
              </v-card>
              <v-card>
                <v-list-item-content>
                  <v-card-title class="headline mx-auto">
                    Configuração
                  </v-card-title>
                  <v-col cols="8" sm="4">
                    <v-text-field
                      v-model="form.numeroSinc"
                      label="Número  máximo de dias sem sincronização"
                    />
                  </v-col>
                  <v-col cols="8" sm="4">
                    <v-text-field
                      v-model="form.numeroRasc"
                      label="Número  máximo de rascunhos no APP"
                    />
                  </v-col>
                </v-list-item-content>
              </v-card>
              <v-card>
                <v-list-item-content>
                  <v-card-title class="headline mx-auto">
                    Permissões
                  </v-card-title>
                  <v-row class="pa-3">
                    <v-col cols="6" sm="4">
                      <v-autocomplete
                        v-model="form.permissions"
                        autocomplete="autocomplete_off_hack_xfr4!k"
                        label="Relatórios "
                        name="permissions"
                        :items="permissions"
                        :loading="loadingPermissions"
                        :disabled="loadingPermissions"
                        item-text="title"
                        item-value="report_id"
                        clearable
                        multiple
                      />
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-card>
              <v-btn
                type="submit"
                :disabled="salvando"
                :loading="salvando"
                :color="!$route.query.id ? 'success' : 'warning'"
                form="form"
              >
                {{ btnNome }}
              </v-btn>

              <router-link
                :disabled="salvando"
                :to="`/${$user.get().role}/central`"
              >
                <v-btn :disabled="salvando" color="error" class="ml-3">
                  Cancelar
                </v-btn>
              </router-link>
            </v-form>
          </div>
        </v-card>
      </template>
    </div>
  </v-card>
</template>
<script>
import { ENV_APP } from '../../../env'
import { validaCPF } from '../../utils/validacoes'

export default {
  data() {
    return {
      edit: false,
      agroindustrias: [],
      salvando: false,
      loading: true,
      loadingEstados: true,
      loadingCidades: false,
      loadingAgroindustrias: true,
      loadingPermissions: true,
      sexos: [{ text: 'Masculino' }, { text: 'Feminino' }],
      maskCpf: '###.###.###-##',
      maskTelCel: '(##) # ####-####',
      maskCep: '##.###-###',
      emailRules: [v => /.+@.+/.test(v) || 'E-mail inválido'],
      telRules: [
        v => !v || v.length === 0 || v.length >= 10 || '* Número inválido',
        v => !!v || '* Obrigatório',
      ],
      cpfRules: [
        v => !!v || '* Obrigatório',
        v => validaCPF(v) || '* CPF inválido',
      ],
      requiredRules: [v => !!v || '* Obrigatório'],
      valid: false,
      btnNome: !this.$route.query.id ? 'Salvar' : 'Salvar Alterações',
      form: {
        id: null, // código do gestor
        nome: null,
        email: null,
        cpf: null,
        sexo: null,
        telCel: null,
        estado: null,
        CodCidade: null,
        bairro: null,
        logradouro: null,
        numero: null,
        complemento: null,
        cep: null,
        telRes: null,
        numeroSinc: null,
        numeroRasc: null,
        permissions: [],
      },
      estado: [],
      cidade: [],
      permissions: [],
      cadastro: this.$route.query.id === 0 ? 1 : 0,
    }
  },
  created() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      this.edit = true
      this.formDados()
      this.loadEstado()
      this.loadPermissions()
    } else {
      this.loadNewForm()
    }
  },
  methods: {
    loadNewForm() {
      this.loadEstado()
      this.loadPermissions()
      this.loading = false
    },
    updateCentral() {
      this.valid = this.$refs.form.validate()

      if (!this.valid) {
        this.Swal.fire(
          'Atenção',
          'Preencha os itens obrigatórios sinalizados com ("*").',
          'warning',
        )
        return false
      } else {
        if (this.form.id) {
          this.salvando = true
          this.api.update
            .central(this.form.id, {
              ...this.form,
              permissions: this.form.permissions.map(permission => {
                return { report_id: permission }
              }),
            })
            .then(response => {
              this.Swal.fire({
                title: 'Sucesso',
                text: response,
                icon: 'success',
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.$router.push({ path: `/${this.$user.get().role}/central` })
              })
            })
            .catch(error => {
              this.Swal.fire(
                'Error ao atualizar o Supervisor!',
                JSON.stringify(error),
                'warning',
              )
              this.salvando = false
            })
        } else {
          this.salvando = true
          this.api.save
            .central({
              ...this.form,
              permissions: this.form.permissions.map(permission => {
                return { report_id: permission }
              }),
            })
            .then(response => {
              this.Swal.fire({
                title: 'Sucesso',
                text: response,
                icon: 'success',
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.$router.push({ path: `/${this.$user.get().role}/central` })
              })
            })
            .catch(error => {
              this.Swal.fire('Error ao criar o supervisor!', error, 'warning')
              this.salvando = false
            })
        }
      }
    },
    formDados() {
      this.api.get.central(this.form.id).then(data => {
        this.form = { ...this.form, ...data }
        this.loadCidade(this.form.estado)

        this.valid = true
        this.loading = false
      })
    },
    loadEstado() {
      this.api.get.estados().then(data => {
        this.estado = data
        this.loadingEstados = false
      })
    },
    loadCidade(CodEstado) {
      this.loadingCidades = true
      this.api.get.cidades(CodEstado).then(data => {
        this.cidade = data
        this.loadingCidades = false
      })
    },
    changeCidade() {
      this.loadCidade(this.form.estado)
    },
    loadPermissions() {
      this.api.get.listReports({ projectId: ENV_APP.ProjectID }).then(data => {
        this.permissions = data
        this.loadingPermissions = false
      })
    },
  },
}
</script>
